import React from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { useEnableInternationalPaymentSwitch } from "../../utils/hooks/useEnableInternationalPaymentSwitch";
import { INTERNATIONAL_PAYMENT_TEXTS } from "./InternationalPayment.constants";
import { InternationalPaymentFields } from "./InternationalPaymentFields";

export const EnableInternationalPaymentSwitch = () => {
  const {
    isEnabled,
    disableSwitch,
    modalOpen,
    setModalOpen,
    formValues,
    formMeta,
    isSubmitting,
    isSubmitDisabled,
    handleToggle,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useEnableInternationalPaymentSwitch();

  return (
    <>
      <SectionUnlockingSwitch
        value={isEnabled}
        onChange={handleToggle}
        disabled={disableSwitch}
      />

      <ExlyModal
        open={modalOpen}
        onClose={() => !isSubmitting && setModalOpen(false)}
        title={INTERNATIONAL_PAYMENT_TEXTS.MODAL_TITLE}
        primaryBtnText={INTERNATIONAL_PAYMENT_TEXTS.PRIMARY_BTN}
        onPrimaryBtnClick={handleSubmit}
        primaryBtnProps={{ disabled: isSubmitDisabled, loading: isSubmitting }}
        showSecondaryBtn
        secondaryBtnText={INTERNATIONAL_PAYMENT_TEXTS.SECONDARY_BTN}
        onSecondaryBtnClick={() => !isSubmitting && setModalOpen(false)}
        backDropClickClose={false}
        escapeKeyDownClose={false}
        desktopModalWidth="500px"
      >
        <InternationalPaymentFields
          formValues={formValues}
          formMeta={formMeta}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </ExlyModal>
    </>
  );
};
